import { Grid } from '@material-ui/core'
import { components } from 'cng-web-lib'
import React from 'react'
import { useParams } from 'react-router-dom'
import SCOInvMgmtApiUrls from 'src/apiUrls/SCOInvMgmtApiUrls'
import pathMap from 'src/paths/PathMap_SCO_InvMgmt'
import CategoryTranslationText from './CategoryTranslationText'
import FormProperties from './Category_FormProperties'

const { form: { CngViewForm },
	button: { CngPrimaryButton, CngSecondaryButton },
} = components

function ViewPage({ history, showNotification }) {
	const { id } = useParams()
	const translatedTextObject = CategoryTranslationText()

	return (
		<CngViewForm
			fieldLevel='toBeChangedByDeveloperIfWantFieldLevelRestriction'
			showNotification={showNotification}
			bodySection={
				<>
					<FormProperties.Fields
						disabled={true}
						showNotification={showNotification}
						id={id}
						isViewOnly={true}
					/>

					<Grid container spacing={3}>
						<Grid item>
							<CngPrimaryButton style={{ marginRight: '10px' }}
								onClick={() => history.push(`${pathMap.SCO_INV_CATEGORY_LIST}/edit/${id}`)}>
								{translatedTextObject.edit}
							</CngPrimaryButton>
							<CngSecondaryButton
								onClick={() => { history.push(pathMap.SCO_INV_CATEGORY_LIST) }}>
								{translatedTextObject.back}
							</CngSecondaryButton>
						</Grid>
					</Grid>
				</>
			}
			formikProps={FormProperties.formikProps}
			toClientDataFormat={FormProperties.toClientDataFormat}
			toServerDataFormat={FormProperties.toServerDataFormat}
			fetch={{
				id: id,
				url: `${SCOInvMgmtApiUrls.GET_CATEGORY_BY_ID}`
			}}

		/>
	)

}

export default ViewPage
